<!-- eslint-disable vue/max-len -->
<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2442 4.21895C11.0022 2.82922 12.9978 2.82922 13.7558 4.21895L22.3867 20.0423C23.1137 21.375 22.149 23 20.6309 23H3.36908C1.85097 23 0.886339 21.375 1.61329 20.0423L10.2442 4.21895Z"
      fill="#FFBE00"
    />
    <path d="M11 16V7H13V16H11ZM11 21V19H13V21H11Z" fill="#050038" />
  </svg>
</template>
